export default {
  properties: {
    allow_regenerate: { type: 'boolean' },
    prefix: { type: 'string' },
  },
};
